import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';

// AIDEV-NOTE: Returns true when student navigation should be locked during a teacher-paced session.
const useSessionNavigationLock = () => {
  const activeSessionId = useSlideShowContext(state => state.activeSessionId);
  const disconnectedSessionId = useSlideShowContext(state => state.disconnectedSessionId);
  const userType = useSlideShowContext(state => state.userType);

  const isTeacherConnected = disconnectedSessionId !== activeSessionId;
  const isNavigationLocked = !!activeSessionId && userType === 'Student' && isTeacherConnected;

  return { isNavigationLocked };
};

export default useSessionNavigationLock;
